import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home/Home";
import Login from "./pages/Login/Login";
import ForgotPassword from "./pages/Login/ForgotPassword";
import ResetPassword from "./pages/Login/ResetPassword";
import Register from "./pages/Register/Register";
import Admin from "./pages/Admin/Admin";
import CreateCategory from "./pages/Admin/CreateCategory";
import CreateSubCategory from "./pages/Admin/CreateSubCategory";
import CreateService from "./pages/Admin/CreateService";
import CreateTimeSlot from "./pages/Admin/CreateTimeSlot";
import Test from "./pages/test";
import Booking from "./pages/Booking/Booking";
import SucessReservate from "./pages/SucessReservate/SucessReservate";
import MyReservations from "./pages/MyReservations/MyReservations";
import PerfilPage from "./pages/Perfil/Perfil";
import EditPerfil from "./pages/Perfil/EditPerfil";
import About from "./pages/About/About";
import Contact from "./pages/Contact/Contact";
import CalendarReservation from "./pages/Admin/CalendarReservation";
import Users from "./pages/Admin/Users";
import ErrorReservation from "./pages/ErrorReservation/ErrorReservation";
import WhatsAppQR from "./pages/Admin/WhatsAppQR";
import EditServices from "./pages/Admin/EditServices";
import Employees from "./pages/Admin/Employees";
import Reservations from "./pages/Reservations/Reservations";
import AdminLogin from "./pages/Admin/Login";
import AdminRoute from "./components/AdminRoute";
import CartPage from "./pages/Cart/Cart";
import DashboardPage from "./pages/Admin/Dashboard";
import CreateReservation from "./pages/Admin/CreateReservation";
import Products from "./pages/Admin/Products";
import ProductSales from "./pages/Admin/ProductSales";
import Attendance from "./pages/Admin/Attendance";
import PublicImages from "./pages/Admin/PublicImages";
import PublicImage from "./pages/PublicImage";
import Catalog from "./pages/Catalog";







function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/publicaciones/:id" element={<PublicImage />} />
      <Route path="/catalogo/:id" element={<PublicImage />} />
      <Route path="/catalogo" element={<Catalog />} />
      <Route path="/iniciar-sesión" element={<Login />} />
      <Route path="/olvide-mi-contrasena" element={<ForgotPassword />} />
      <Route path="/restablecer-contrasena" element={<ResetPassword />} />
      <Route path="/registrar" element={<Register />} />
      <Route path="/reservar/:serviceId/:employeeId" element={<Booking />} />
      <Route path="/carrito" element={<CartPage />} />
      <Route path="/reserva/realizada" element={<SucessReservate />} />
      <Route path="/reserva/error" element={<ErrorReservation />} />

      <Route path="/mis-reservas" element={<MyReservations />} />
      <Route path="/perfil" element={<PerfilPage />} />
      <Route path="/actualizar-perfil" element={<EditPerfil />} />
      <Route path="/sobre-nosotros" element={<About />} />
      <Route path="/contactanos" element={<Contact />} />
      <Route path="/admin/login" element={<AdminLogin />} />





      <Route path="/admin" element={<AdminRoute><Admin /></AdminRoute>} >
      <Route index element={<DashboardPage />} />
      <Route path="/admin" element={<DashboardPage />} />
      <Route path="usuarios" element={<Users />} />

      <Route path="empleados" element={<Employees />} />
      <Route path="productos" element={<Products />} />
      <Route path="ventas-productos" element={<ProductSales />} />
      <Route path="asistencia" element={<Attendance />} />
      <Route path="imagenes-publicas" element={<PublicImages />} />
      <Route path="catalogo" element={<PublicImages />} />

      
      <Route path="crear-categoria" element={<CreateCategory />} />
      <Route path="crear-subcategoria" element={<CreateSubCategory />} />
      <Route path="crear-servicio" element={<CreateService />} />
      <Route path="crear-horario" element={<CreateTimeSlot />} />
      <Route path="servicios" element={<EditServices />} />

      <Route path="reservas" element={<Reservations />} />
      <Route path="nueva-reservacion" element={<CreateReservation />} />
      <Route path="agenda" element={<CalendarReservation />} />
      <Route path="agenda/:date" element={<CalendarReservation />} />
      <Route path="qr" element={<WhatsAppQR />} />


      </Route>
      <Route path="/test" element={<Test />} />


    </Routes>
  );
}

export default App;
